import { useRecoilValue, useSetRecoilState } from 'recoil'
import { selectedProductState, stepState } from '../states/messageState'
import { useInViewFooter } from './useInViewFooter'
import { useSendMessage } from './useSendMessage'

export const useCheckAddress = () => {
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const product = useRecoilValue(selectedProductState)

  const { handleInViewFooter } = useInViewFooter()
  const setCurrentStep = useSetRecoilState(stepState)

  const checkAddress = async (isChangeEmail: boolean) => {
    const message = '配送先住所はこちらの住所から変わっていますか？'

    const addMessage = isChangeEmail ? handleAddMessage : handleAddSenderParent

    await addMessage('bot', message)

    const { address, building, city, postalNumber, prefecture } = product.shippingAddress

    await handleAddMessage('bot', `${postalNumber} ${prefecture} ${city} ${address} ${building}`)
    handleInViewFooter()
    setCurrentStep('chooseChangeAddress')
  }

  return { checkAddress }
}
